import React, { useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import Context from "../context/Context";
import { isEmpty } from "lodash";

import helpIcon from "../assests/helpIcon.svg";
import { useUserAuth } from "../context/UserAuthContext";
import { createSearchParams } from "react-router-dom";
import ErrorReportPopup from "../Components/ErrorReportPopup/ErrorReportPopup";
import InstallButton from "../Components/InstallButton/InstallButton";
import NavigationFooter from "../Components/NavigationFooter/NavigationFooter";
import EmailAccCreatedPopup from "../Components/EmailAccCreatedPopup/EmailAccCreatedPopup";
import ProtecedRoute from "../ProtecedRoute";

export default function Layout() {
  const {
    details,
    campaignSpecs,
    campaignMetaData,
    setReportErrorPopup,
    reportErrorPopup,
    ocassionDataofEvent,
    isMobile,
  } = useContext(Context);
  const {
    currentUser,
    searchParams,
    emailAccountCreated,
    setEmailAccountCreated,
    setPreviousLocation,
  } = useUserAuth();

  let Background = campaignSpecs?.campaignBackground;
  const [cssUrl, setCssUrl] = useState("");
  // let Background = "";
  const location = useLocation();
  const navigate = useNavigate();
  const from = searchParams.get("from");

  let backgroundStyle = {
    backgroundImage: `url(${Background})`,
    backgroundAttachment: "fixed",
    backgroundPosition: "center",
    backgroundSize: "cover",
  };

  const openErrorReportPopup = () => {
    setPreviousLocation(window.location.pathname);

    if (currentUser) {
      setReportErrorPopup(true);
    } else {
      navigate(
        {
          pathname: `/signup`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        {
          state: {
            previousLocation: location.pathname,
          },
        }
      );
    }
  };
  useEffect(() => {
    if (campaignMetaData?.organizerName == "poster") {
      setCssUrl(
        `${process.env.REACT_APP_CAMPAIGNDETAILS}/${ocassionDataofEvent?.orgDomain}/${ocassionDataofEvent?.campaignUniqueText}/template.css`
      );
    } else {
      if (!isEmpty(details)) {
        setCssUrl(
          `${process.env.REACT_APP_CAMPAIGNDETAILS}/${details?.orgDomain}/${details?.campaignUniqueText}/template.css`
        );
      } else {
        setCssUrl(
          `${process.env.REACT_APP_CAMPAIGNDETAILS}/${campaignMetaData?.organizerName}/${campaignMetaData?.campaignName}/template.css`
        );
      }
    }
  }, [details, ocassionDataofEvent]);

  return (
    <div>
      {/* <DesktopNavBar /> */}
      {/* <InstallButton /> */}

      <link rel="stylesheet" type="text/css" href={cssUrl} />
      <div
        style={backgroundStyle}
        className={`${!isMobile && from == "gvHome" && "pb-[67px]"}`}
      >
        <Outlet />
      </div>
      {!location?.pathname?.startsWith("/help") && (
        <img
          src={helpIcon}
          alt=""
          className={`object-cover  overflow-hidden   cursor-pointer  h-[50px] w-[50px]  fixed ${
            !isMobile && from == "gvHome" ? "bottom-[90px]" : "bottom-[20px]"
          }  right-[20px] z-[10]`}
          onClick={openErrorReportPopup}
        />
      )}
      {!isMobile && from == "gvHome" && <NavigationFooter />}
      {emailAccountCreated && (
        <EmailAccCreatedPopup setPopup={setEmailAccountCreated} />
      )}
      {reportErrorPopup && <ErrorReportPopup setPopup={setReportErrorPopup} />}
    </div>
  );
}
